import { from } from 'rxjs';
/**
 * @internal
 */
export class ConnectMock {
    constructor() {
        this.isConnected = true;
        this.isWorking = false;
    }
    get isConnectedSubject() {
        return this.socket.isConnectedSubject;
    }
    get isConnected$() {
        var _a;
        return (_a = this.socket.isConnectedSubject) === null || _a === void 0 ? void 0 : _a.asObservable();
    }
    send(message, needsHandling) {
        return Promise.resolve(this.nextMessage);
    }
    setValidSession(valid) {
        this.socket.hasValidSession = valid;
    }
    httpMode() {
        return false;
    }
    commitEvent(eventName, params) {
        return Promise.resolve(this.nextMessage);
    }
    connect(host) {
        return Promise.resolve(this.isConnected);
    }
    disconnect() { }
    getMetadata(resourceName) {
        return Promise.resolve(this.nextMetadata);
    }
    request(resourceName, params) {
        this.requestParams = params;
        return Promise.resolve(this.nextMessage);
    }
    snapshot(resourceName, params) {
        return Promise.resolve(this.nextMessage);
    }
    stream(resourceName, onMessage, onError, params) {
        return from(Promise.resolve(this.nextMessage));
    }
    getMoreRows(sourceRef) {
        return Promise.resolve(this.nextMessage);
    }
    dataLogoff(sourceRef) {
        return Promise.resolve(this.nextMessage);
    }
    getJSONSchema(resourceName) {
        return Promise.resolve(this.nextJSONSchema);
    }
}
